function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgPath = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 38 14 L 35 14 C 29.484375 14 25 18.484375 25 24 C 25 29.515625 29.484375 34 35 34 L 38 34 C 43.515625 34 48 29.515625 48 24 C 48 18.484375 43.515625 14 38 14 M 38 30 L 35 30 C 31.691406 30 29 27.308594 29 24 C 29 20.691406 31.691406 18 35 18 L 38 18 C 41.308594 18 44 20.691406 44 24 C 44 27.308594 41.308594 30 38 30 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 13 14 L 10 14 C 4.484375 14 0 18.484375 0 24 C 0 29.515625 4.484375 34 10 34 L 13 34 C 18.515625 34 23 29.515625 23 24 C 23 18.484375 18.515625 14 13 14 M 13 30 L 10 30 C 6.691406 30 4 27.308594 4 24 C 4 20.691406 6.691406 18 10 18 L 13 18 C 16.308594 18 19 20.691406 19 24 C 19 27.308594 16.308594 30 13 30 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42A5F5"
    },
    d: "M 33 22 L 15 22 C 13.894531 22 13 22.894531 13 24 C 13 25.105469 13.894531 26 15 26 L 33 26 C 34.105469 26 35 25.105469 35 24 C 35 22.894531 34.105469 22 33 22 "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPath, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/path.521b193c.svg";
export { ForwardRef as ReactComponent };